import Api from '../http.service';

/**
 * get profile commission by Id
 * @param {String} id
 */
export const getCommissionById = (id) =>
  Api.GET({ url: `profile_commission/commission/${id}` });

/**
 * update profile commissin
 * @param {Object} payload
 * @param {String} payload.id
 * @param {Array} payload.data
 */
export const updateBulk = (payload) =>
  Api.PUT({ url: 'profile_commission/bulk', data: payload.data });
